import { getInviteStatusColumns, SubRowTable, SubRowTableColumn } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';

import { ReferralSessionResult } from './types';

type Invite = ReferralSessionResult['invites'][number];
type ReferralSessionInvitesProps = {
  readonly session: ReferralSessionResult;
};

const ReferralSessionInvites = ({ session }: ReferralSessionInvitesProps) => {
  const { t } = useTranslation();

  const columns: SubRowTableColumn<Invite>[] = [
    {
      header: t('model.common.respondentTypeLabel'),
      render: (invite) => t(`model.common.respondentType.${invite.respondentType}`),
    },
    {
      header: t('model.common.respondentName'),
      render: (invite) => `${invite.givenName} ${invite.familyName}`,
    },
    ...getInviteStatusColumns<Invite>(t),
  ];

  return <SubRowTable columns={columns} emptyMessage={t('page.referrals.invites.none')} rows={session.invites} />;
};

export { ReferralSessionInvites };
